// extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__bE05b"};